import { render, staticRenderFns } from "./SafetyCheckBasicInfo.vue?vue&type=template&id=8deffea4&scoped=true&"
import script from "./SafetyCheckBasicInfo.vue?vue&type=script&lang=js&"
export * from "./SafetyCheckBasicInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8deffea4",
  null
  
)

export default component.exports